

function FormSuccess({ formData, setFormData }){
    return (
        <div className="form-success">
            <h1>Thank you for registering!</h1>
        </div>
    );
}

export default FormSuccess